import styled from "styled-components";

export const LogContainerUserStyled = styled.div`
  .show_loading {
    height: calc(100vh - 85px);
    display: flex;
    align-items: center;
    justify-content: center;
  }

  min-height: calc(100vh - 200px);
  background: ${({ theme }) => theme.COLORS.WHITE_1};
  border-top-left-radius: 18px;
  border-top-right-radius: 18px;

  .layer_one {
    .head_wrap_layout {
      margin-bottom: 32px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .h_33 {
        width: 33%;
        font-size: ${({ theme }) => theme.FONT.SIZE.S32};
        font-family: ${({ theme }) => theme.FONT.STYLE.BOLD};
        color: ${({ theme }) => theme.COLORS.PURPLE_1};
        &.center {
          display: flex;
          flex-direction: column;
          align-items: center;
        }
        &.flex {
          display: flex;
          column-gap: 10px;
          justify-content: flex-end;
          flex-wrap: wrap;
          row-gap: 10px;
        }
        .text_c {
          text-align: center;
          white-space: nowrap;
        }
        .g_h_text {
          text-align: center;
          font-size: ${({ theme }) => theme.FONT.SIZE.S20};
          font-family: ${({ theme }) => theme.FONT.STYLE.REGULAR};
          color: ${({ theme }) => theme.COLORS.PURPLE_1};
        }
        .bw140 {
          width: 140px;
        }
        .back_click {
          display: flex;
          cursor: pointer;
        }
      }
    }
  }
  .filter_show {
    margin-top: 47px;
    display: flex;
    align-items: center;
    column-gap: 20px;
    .box_date {
      width: 216px;
    }
  }
  .layer_two {
    margin-top: 26px;
  }

  .show_detail_log {
    background: ${({ theme }) => theme.COLORS.WHITE_1};
    width: 340px;
    padding: 20px;
    padding-top: 28px;
    border-radius: 16px;
    border: 1px solid ${({ theme }) => theme.COLORS.GRAY_25};
    position: relative;
    .svg_c {
      position: absolute;
      top: 12px;
      right: 12px;
      cursor: pointer;
    }
    .group_h {
      display: flex;
      font-size: ${({ theme }) => theme.FONT.SIZE.S16};
      font-family: ${({ theme }) => theme.FONT.STYLE.REGULAR};
      color: ${({ theme }) => theme.COLORS.PURPLE_1};
      column-gap: 10px;
      align-items: baseline;
      .big_text {
        font-family: ${({ theme }) => theme.FONT.STYLE.SEMIBOLD};
        color: ${({ theme }) => theme.COLORS.BLACK_6};
        flex: 1;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
      }
      .date_show {
        width: 147px;
      }
    }
    .show_point {
      font-size: ${({ theme }) => theme.FONT.SIZE.S20};
      font-family: ${({ theme }) => theme.FONT.STYLE.BOLD};
      color: ${({ theme }) => theme.COLORS.PURPLE_1};
      margin-top: 12px;
      border-radius: 8px;
      padding: 6px 20px;
      background: ${({ theme }) => theme.COLORS.GRAY_10};
      .line_txt {
        display: flex;
        flex-direction: column;
        align-items: center;
        .lbl {
          // width: 140px;
        }
      }
    }
    .group_list {
      margin-top: 30px;
      display: flex;
      flex-direction: column;
      row-gap: 10px;
      max-height: 328px;
      overflow: auto;
      ::-webkit-scrollbar {
        width: 6px;
        height: 6px;
      }
      ::-webkit-scrollbar-button {
        width: 0px;
        height: 0px;
      }
      ::-webkit-scrollbar-thumb {
        background: #cccccc;
        border: 0px none #ffffff;
        border-radius: 50px;
      }
      ::-webkit-scrollbar-thumb:hover {
        background: #cccccc;
      }
      ::-webkit-scrollbar-thumb:active {
        background: #c2c2c2;
      }
      ::-webkit-scrollbar-track {
        background: #ebebeb;
        border: 0px none #ffffff;
        border-radius: 50px;
      }
      ::-webkit-scrollbar-track:hover {
        background: #e6e6e6;
      }
      ::-webkit-scrollbar-track:active {
        background: #ebebeb;
      }
      ::-webkit-scrollbar-corner {
        background: transparent;
      }
      .group_name {
        column-gap: 34px;
        display: flex;
        font-size: ${({ theme }) => theme.FONT.SIZE.S16};
        font-family: ${({ theme }) => theme.FONT.STYLE.REGULAR};
        color: ${({ theme }) => theme.COLORS.GRAY_23};
        .id_show {
          width: 30%;
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
        }
        .name_show {
          width: 70%;
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
        }
      }
    }
  }

  .box_line_icon {
    column-gap: 20px;
    display: flex;
    align-items: center;
    width: 100%;
    .value_lbl {
      flex: 1;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
    }
    .svg_page {
      display: flex;
      width: 24px;
    }
  }

  // @media (max-width: ${({ theme }) => theme.SCREENS.IPAD}) {
  //   .header_col  {
  //     &.showHead {
  //       width: 270px;
  //       max-width: 270px;
  //     }
  //   }
  //   .body_col {
  //     &.showHead {
  //       width: 270px;
  //       max-width: 270px;
  //     }
  //   }
  //   .showName {
  //     max-width: 270px;
  //   }
  // }

  // @media (max-width: ${({ theme }) => theme.SCREENS.TABLET}) {
  //   .header_col  {
  //     &.showHead {
  //       width: 200px;
  //       max-width: 200px;
  //     }
  //     &.showUser {
  //       width: 100px;
  //       max-width: 100px;
  //     }
  //     &.showDate {
  //       width: 100px;
  //       max-width: 100px;
  //     }
  //   }
  //   .body_col  {
  //     &.showHead {
  //       width: 200px;
  //       max-width: 200px;
  //     }
  //     &.showUser {
  //       width: 100px;
  //       max-width: 100px;

  //     }
  //     &.showDate {
  //       width: 100px;
  //       max-width: 100px;
  //     }
  //   }
  //   .showName {
  //     width: 180px;
  //     max-width: 180px;
  //   }
  // }
`;
